/**
 * Единственное место, где читается `import.meta.env`. Остальной код берёт
 * значения отсюда: опечатку в имени переменной ловит компилятор, а не пустой
 * экран в Telegram, и в одном месте видно, от чего приложение зависит снаружи.
 */

/** Хвостовой слэш в VITE_BACKEND_URL — частая опечатка, даёт `//me` в путях. */
const backendUrl = (import.meta.env.VITE_BACKEND_URL ?? 'http://localhost:3000').replace(
  /\/+$/,
  '',
);

export const env = {
  backendUrl,
  /** Подписанный initData для запуска вне Telegram, см. scripts/gen-mock-init-data.mjs. */
  mockLaunchParams: import.meta.env.VITE_MOCK_LAUNCH_PARAMS,
  isDev: import.meta.env.DEV,
} as const;
